// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a50cd160","455":"2b9393af","977":"d73c4c22"}[chunkId] + ".chunk.js";
};